import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getFactoriesByGroupID,
    getAllRoutesByFactoryID,
    getCollectionSummaryReportData,
    getCollectionPointsByOperationentityGroupID,
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID','groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}


async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}


async function getCollectionSummaryReportData(factoryID,collectionPointID,date) {
    var model = {
        operationEntityID: parseInt(factoryID),
        collectionPointID: parseInt(collectionPointID),
        date: date,
    };
    const response = await CommonPost('/api/CollectionSummaryReport/GetCollectionSummaryReport', null, model);
    return response.data;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}
